module.exports = __webpack_public_path__ + "img/pic01.bdda1136.png";